import React from 'react';
import styled from 'styled-components';
import { Column, constants } from '@narvar/nth-grid';

const smallBreakpoint = constants.breakpointMinWidths[constants.WIDTH_SM];

// A negative margin is applied to avoid having the dismiss ("x" button)
// from the Alert container push this div down
export const FirstCol = styled(Column)`
  margin-top: -1rem;
  padding-bottom: 1.5rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: 0;
    padding-bottom: 0;
    padding-right: 1.5rem;
  }
`;

export const SecondCol = styled(Column)`
  @media (min-width: ${smallBreakpoint}) {
    padding: 0;
  }
`;

// To match the design for dividers in both the vertical and horizontal
// directions between the columns, simulate a divider by adding a border
// to the middle column.
// There could be some risk with this approach if either the first or
// third column become taller in height when in a horizontal
// arrangement.
interface DividerWrappedDivProps {
  dividerStyles?: React.CSSProperties;
}

export const DividerWrappedDiv = styled.div<DividerWrappedDivProps>`
  padding: 1.75rem 0rem;
  border-style: ${({ dividerStyles: s }) => s?.borderStyle ?? 'solid'};
  border-color: ${({ dividerStyles: s }) => s?.borderColor ?? '#e0e0e0'};

  border-top-width: ${({ dividerStyles: s }) => s?.borderWidth ?? '1px'};
  border-bottom-width: ${({ dividerStyles: s }) => s?.borderWidth ?? '1px'};
  border-left-width: 0;
  border-right-width: 0;
  @media (min-width: ${smallBreakpoint}) {
    border-top-width: 0;
    border-bottom-width: 0;
    border-left-width: ${({ dividerStyles: s }) => s?.borderWidth ?? '1px'};
    border-right-width: ${({ dividerStyles: s }) => s?.borderWidth ?? '1px'};
    padding: 0.25rem 1.5rem;
  }
`;

// A negative margin is applied to avoid having the dismiss ("x" button)
// from the Alert container push this div down
export const ThirdCol = styled(Column)`
  padding-top: 1.75rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: -1rem;
    padding-top: 0;
    padding-left: 1.5rem;
  }
`;
